<script>
    import Icon from '../icons/Icon.svelte';

    export let supportSettings = {
        whatsapp: '',
        phone: '',
        email: '',
        message: ''
    };
    export let inputSupportWhatsapp = '';
    export let inputSupportPhone = '';
    export let inputSupportEmail = '';
    export let inputSupportMessage = '';
    export let isSavingSupport = false;
    export let onSaveSupportSettings = () => {};
</script>

<div class="tab-pane">
    <section class="master-card">
        <div class="card-header">
            <div class="card-title-group">
                <Icon name="message-circle" size={20} />
                <h3>Canais Oficiais de Suporte ao Cliente SaaS</h3>
            </div>
            <span class="card-subtitle">Configure os contatos oficiais de suporte técnico exibidos para os donos de restaurantes nos aplicativos Desktop e Web.</span>
        </div>

        <div class="form-grid">
            <div class="form-group">
                <label for="sup-wa">WhatsApp Oficial de Atendimento *</label>
                <div class="input-icon-box">
                    <span class="input-icon">
                        <Icon name="whatsapp" size={15} />
                    </span>
                    <input
                        id="sup-wa"
                        type="text"
                        bind:value={inputSupportWhatsapp}
                        placeholder={supportSettings.whatsapp || '(11) 99999-9999'}
                        class="form-input with-icon"
                    />
                </div>
                <small class="input-hint">Número utilizado para gerar o link direto "Falar com Suporte" nos painéis dos clientes.</small>
            </div>

            <div class="form-group">
                <label for="sup-email">E-mail de Suporte / Help Desk</label>
                <input
                    id="sup-email"
                    type="email"
                    bind:value={inputSupportEmail}
                    placeholder={supportSettings.email || 'suporte@seusaas.com'}
                    class="form-input"
                />
            </div>

            <div class="form-group">
                <label for="sup-phone">Telefone Fixo / 0800 (Opcional)</label>
                <input
                    id="sup-phone"
                    type="text"
                    bind:value={inputSupportPhone}
                    placeholder={supportSettings.phone || '(11) 4000-0000'}
                    class="form-input"
                />
            </div>

            <div class="form-group full-width">
                <label for="sup-msg">Mensagem Padrão Pré-preenchida no WhatsApp</label>
                <textarea
                    id="sup-msg"
                    rows="3"
                    bind:value={inputSupportMessage}
                    placeholder={supportSettings.message || 'Olá, preciso de suporte no sistema MataFome.'}
                    class="form-textarea"
                ></textarea>
                <small class="input-hint">Texto inicial que aparece preenchido na conversa quando o restaurante clica no botão de suporte.</small>
            </div>
        </div>

        <div class="card-footer">
            <button
                type="button"
                class="btn-save-master"
                disabled={isSavingSupport}
                on:click={onSaveSupportSettings}
            >
                <Icon name="check" size={15} />
                <span>{isSavingSupport ? 'Salvando...' : 'Salvar Canais de Suporte'}</span>
            </button>
        </div>
    </section>
</div>

<style>
    .tab-pane {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .master-card {
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 12px;
        padding: 24px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
    }

    .card-header {
        margin-bottom: 20px;
    }

    .card-title-group {
        display: flex;
        align-items: center;
        gap: 10px;
        color: #0F172A;
    }

    .card-title-group h3 {
        font-size: 16px;
        font-weight: 700;
        margin: 0;
        color: #0F172A;
    }

    .card-subtitle {
        font-size: 13px;
        color: #64748B;
        display: block;
        margin-top: 4px;
        line-height: 1.4;
    }

    .form-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
        gap: 16px;
        margin-bottom: 22px;
    }

    .full-width {
        grid-column: 1 / -1;
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .form-group label {
        font-size: 12px;
        font-weight: 600;
        color: #475569;
    }

    .input-icon-box {
        position: relative;
        display: flex;
        align-items: center;
    }

    .input-icon {
        position: absolute;
        left: 12px;
        color: #16A34A;
        pointer-events: none;
        display: flex;
    }

    .form-input {
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        border-radius: 8px;
        padding: 10px 14px;
        color: #0F172A;
        font-size: 13px;
        width: 100%;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
        transition: border-color 0.2s, box-shadow 0.2s;
    }

    .form-input.with-icon {
        padding-left: 36px;
    }

    .form-input:focus, .form-textarea:focus {
        outline: none;
        border-color: #FF6A00;
        box-shadow: 0 0 0 2px rgba(255, 106, 0, 0.15);
    }

    .form-textarea {
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        border-radius: 8px;
        padding: 10px 14px;
        color: #0F172A;
        font-size: 13px;
        line-height: 1.45;
        resize: vertical;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
        transition: border-color 0.2s, box-shadow 0.2s;
    }

    .input-hint {
        font-size: 12px;
        color: #94A3B8;
        line-height: 1.35;
    }

    .card-footer {
        display: flex;
        justify-content: flex-end;
        border-top: 1px solid #E2E8F0;
        padding-top: 18px;
    }

    .btn-save-master {
        background: #FF6A00;
        border: 1px solid #EA580C;
        color: #FFFFFF;
        padding: 9px 22px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        box-shadow: 0 1px 3px rgba(255, 106, 0, 0.2);
        transition: all 0.15s ease;
    }

    .btn-save-master:hover:not(:disabled) {
        background: #EA580C;
        box-shadow: 0 3px 8px rgba(255, 106, 0, 0.3);
    }

    .btn-save-master:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
</style>
